import React, { useEffect, useState } from 'react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import Card from './Card';
//import { DashboardCardData } from '../../data/CardData';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import businessIcon from "../../assets/Images/offers.PNG"
import hotelIcon from "../../assets/Images/city.png"
import infraIcon from "../../assets/Images/infra.PNG"
import installIcon from "../../assets/Images/installation.PNG"
import faultRepairIcon from "../../assets/Images/services.PNG"
import provisionIcon from "../../assets/Images/provision.png"
import searchI from "../../assets/Images/logosearch.png"
import * as api from '../../api_function';
import { fetchFirebaseToken } from "../../firebase.js";
import Cookies from 'js-cookie';
// import searchI from "../../assets/Images/"
// import searchI from "../../assets/Images/"

const CardList = () => {


    const [bdrUserAccess, setBdrUserAccess] = useState("");

    const businessEmails = [
        "salesperson1@spectra.co",
        "dhairya.chouhan@spectra.co",
        "sanjeet.roshan@spectra.co",
        "amit.tripathi@spectra.co",
        "parveen.kumar@spectra.co",
        "rajvardhan.tyagi@spectra.co",
        "amit.tripathi@spectra.co",
        "rajvardhan.tyagi@spectra.co",
        "manager1@spectra.co",
        "ajeet.sharma2@spectra.co",
        "anil.sharma3@spectra.co",
        "anuj.pandey@spectra.co",
        "bhanuk.choubey@spectra.co",
        "binay.singh@spectra.co",
        "deepakk.pathak@spectra.co",
        "govind.kumar@spectra.co",
        "harimohan.yadav@spectra.co",
        "oriya.bashir@spectra.co",
        "praveen.kumar2@spectra.co",
        "rajeev.sinha@spectra.co",
        "rakesh.kumar2@spectra.co",
        "rakesh.mishra@spectra.co",
        "rishikesh.srivastava@spectra.co",
        "sanjeev.gupta@spectra.co",
        "yogesh.ahuja@spectra.co",
        "vivek.chauhan1@spectra.co",
        "venugopal.g1@spectra.co",
        "m.uthamalingan@spectra.co",
        "Dhanush.raj@spectra.co",
        "gs.karthik@spectra.co",
        "manivannan.t1@spectra.co"
    ]

    const businessBdrEmails = [
        "salesperson1@spectra.co",
        "gadinaga.nikhil@spectra.co",
        "manager1@spectra.co",
        "parveen.kumar@spectra.co",
        "avinash3@spectra.co",
        "gaurav.thapliyal@spectra.co",
        "harshit.saxena@spectra.co",
        "isha.thakur@spectra.co",
        "keshav.isar@spectra.co",
        "manish5@spectra.co",
        "mohd.kaif@spectra.co",
        "archana.shreewastav@spectra.co",
        "govindk.yadav@spectra.co",
        "rahul.verma@spectra.co",
        "ritik.sharma@spectra.co",
        "saumya1@spectra.co",
        "shivam.trivedi1@spectra.co",
        "snay.choudhary@spectra.co",
        "yogesh.kumar2@spectra.co",
        "shiva.k@spectra.co",
        "santhosh.nr@spectra.co",
        "thumma.reddy@spectra.co",
        "vasisht.rampriya@spectra.co",
        "n.abilash@spectra.co",
        "nishan.cherian@spectra.co"
    ]

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    };
    useEffect(() => {
        const fetchData = async () => {
            let gmcToken = sessionStorage.getItem('gmcToken');
            try {
                if (isMobileDevice()) {
                    if (!gmcToken || gmcToken === 'undefined') {
                        console.warn("⚠️ gmcToken not found, generating new token...");
                        gmcToken = await fetchFirebaseToken(); // Await to get the token
                    }
                    if (!gmcToken || gmcToken === 'undefined') {
                        console.warn("❗ Skipping saveDeviceToken API: gmcToken still not available");
                    } else {
                        const ApiUrl = process.env.REACT_APP_API_URL;
                        const RequestBody = {
                            "Action": "saveDeviceToken",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "user_name": sessionStorage.getItem('userEmail'),
                            "user_token": sessionStorage.getItem('gmcToken')
                        };
                        const Response = await fetch(ApiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(RequestBody),
                        });
                        const response = await Response.json();
                        // console.log("response",response)
                        if (response) {
                            try {
                                const ApiUrl = "https://oneml.spectra.co/getNotificationDetailsForFFA";
                                const RequestBody = {
                                    "Action": "saveDeviceToken",
                                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                    "user_name": sessionStorage.getItem('userEmail'),
                                    "user_token": sessionStorage.getItem('gmcToken') || ""
                                };
                                const Response = await fetch(ApiUrl, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(RequestBody),
                                });
                                const response = await Response.json();
                                // console.log("response",response)

                            } catch (error) {
                                console.error("Error fetching  data:", error);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching  data:", error);
            }
        };
        fetchData();

    }, []);

    useEffect(() => {
        const fetchData = async () => {

            try {
                setIsLoading(true);
                const fetchUseraccessData = await api.getAllUsersRoles();
                // console.log("fetchUseraccessData",fetchUseraccessData?.data?.profi);

                setBdrUserAccess(fetchUseraccessData?.data?.mra);

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [])



    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "authentication",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    user_name: sessionStorage.getItem('userName').split("@")[0],
                    user_password: sessionStorage.getItem('password'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                if (!response.ok) {
                    throw new Error(`API request failed with status ${response.status}`);
                }
                const responseData = await response.json();
                if (responseData.Status == "Failure") {
                    alert(responseData.ErrorDesc);
                    // toast.warning(responseData.ErrorDesc, {
                    //     position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    // });
                    // Clear auth artifacts so Login doesn't auto-redirect back to dashboard
                    sessionStorage.clear();
                    localStorage.clear();
                    Cookies.remove('userName');
                    Cookies.remove('password');
                    Cookies.remove('userEmail');
                    Cookies.remove('gmcToken');
                    navigate("/", { replace: true });
                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [])


    const userName = sessionStorage.getItem("userName");
    // console.log("userName ", userName);


    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const redirectSalesBusiness = async () => {
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail') == "P_Maya.Iyer" ? "P_Maya.Iyer@spectra.co" : sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "S",
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData);
            // console.log("Sales Business valid user API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.data.UserStatus == "Enabled") {
                // console.log('Actual Data:', responseData.Response.data);
                sessionStorage.setItem("Role", responseData ? responseData.Response.data.Role : "")
                sessionStorage.setItem("PrimaryEmail", responseData ? responseData.Response.data.PrimaryEmail : "")
                sessionStorage.setItem("empId", responseData ? responseData?.Response?.data?.EmployeeID : "")
                // navigate("/business");
                toast.warning("Access Denied , Please Use New CRM App", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                });
                if (responseData.Response.data.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                //     toast.warning(`${errorMessage}`, {
                //       position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                //   });
                // navigate("/business");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const redirectSalesBusinessProfi = async () => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 500));
            // navigate("/cardListProfi");
            toast.warning("Access Denied , Please Use New CRM App", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        } finally {
            setIsLoading(false);
        }
    }

    const redirectSalesBusinessMra = async () => {

        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail') == "P_Maya.Iyer" ? "P_Maya.Iyer@spectra.co" : sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "S",
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData);
            // console.log("Sales Business valid user API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.data.UserStatus == "Enabled") {
                // console.log('Actual Data:', responseData.Response.data);
                sessionStorage.setItem("RoleProFi", responseData ? responseData.Response.data.Role : "")
                sessionStorage.setItem("PrimaryEmailProFi", responseData ? responseData.Response.data.PrimaryEmail : "")

                const userEmail = responseData.Response.data.PrimaryEmail?.toLowerCase();
                const bdrEmailsLower = bdrUserAccess.map(email => email.toLowerCase());

                if (bdrEmailsLower.includes(userEmail)) {
                    // navigate("/businessMraCardList");
                    toast.warning("Access Denied , Please Use New CRM App", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 3000,
                    });
                } else {
                    toast.warning("Access Denied", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }

                if (responseData.Response.data.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                //     toast.warning(`${errorMessage}`, {
                //       position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                //   });
                // navigate("/business");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const redirectSalesBroadband = async () => {
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL_1
            const requestData = {
                "Action": "getvalidate",
                "Authkey": "AdgT6SnjAkeLqlkE4",
                "Password": sessionStorage.getItem('password'),
                "UName": sessionStorage.getItem('userEmail') == "P_Maya.Iyer" ? "P_Maya.Iyer@spectra.co" : sessionStorage.getItem('userEmail'),
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData.Response.UserStatus);

            // console.log("API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.UserStatus == "Enabled"
            ) {
                // console.log('Actual Data:', responseData.Response.Data);
                sessionStorage.setItem("empId", responseData ? responseData?.Response?.EmployeeID : "")
                // navigate("/broadband");
                toast.warning("Access Denied , Please Use New CRM App", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                });

                if (responseData.Response.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                toast.warning(`${errorMessage}`, {
                    position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                });
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const redirectInstallation = async () => {
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "I"
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            // if (!response.ok) {
            //     throw new Error(`API request failed with status ${response.status}`);
            // }
            const responseData = await response.json();
            // console.log("responseData.Status", responseData.Status);
            if (responseData.Status === "Success") {
                // console.log('Actual Data:', responseData.Response.Data);
                sessionStorage.setItem("emailId", responseData ? responseData.Response[0].emailId : "")
                sessionStorage.setItem("field_force", responseData ? responseData.Response[0].field_force : "")
                sessionStorage.setItem("installation", responseData ? responseData.Response[0].installation : "")
                sessionStorage.setItem("name", responseData ? responseData.Response[0].name : "")
                sessionStorage.setItem("userId", responseData ? responseData.Response[0].userId : "")
                sessionStorage.setItem("vendorCode", responseData ? responseData.Response[0].vendorCode : "")
                // sessionStorage.setItem("empId",responseData ? responseData?.Response?.data?.EmployeeID : "")
                // navigate("/installation");
                toast.warning("Access Denied , Please Use New CRM App", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                });
            } else {

                toast.warning("Access Denied", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }


    const redirectfaultRepair = async () => {
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "F"
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            if (responseData && responseData.Response && responseData.Status === "Success") {
                // Extract reportingManager from the first response object
                const rawReportingManager = responseData.Response[0].reportingManager;
                // Remove 'IN' from the beginning if it exists
                const reportingManager = rawReportingManager.startsWith("IN")
                    ? rawReportingManager.substring(2)
                    : rawReportingManager;
                // Store the cleaned reportingManager in sessionStorage
                sessionStorage.setItem("reportingManager", reportingManager);
                sessionStorage.setItem("PrimaryEmail", responseData ? responseData.Response[0].emailId : "");
                sessionStorage.setItem("engId", responseData ? responseData.Response[0].userId : "")
                // sessionStorage.setItem("empId",responseData ? responseData?.Response?.data?.EmployeeID : "")
                navigate("/faultRepair");
            } else {
                toast.warning("Access Denied", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const redirectCustomerSR = async () => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 2000));
            navigate("/customerSR");
        } finally {
            setIsLoading(false);
        }
    }

    const redirectCustomerInfra = async () => {
        try {
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 2000));
            navigate("/customerInfra");
        } finally {
            setIsLoading(false);
        }
    }




    return (
        <div className="container-fluid" style={{ marginTop: "60px" }}>
            {isLoading && (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={loader} alt='loading....' ></img>
                    </div>
                </div>
            )}
            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                {/* {DashboardCardData.map((data, id) => (
                    <div className="col" key={id} onClick={() => redirectPage(data.path)}>
                        <Card icon={data.icon} title={data.title} />
                    </div>
                ))} */}
                {/* SALES : BUSINESS card */}
                <div className="col" onClick={redirectSalesBusiness}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={businessIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                {/* <i className="fa-solid fa-percent p-2 m-3"></i> */}
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden">SALES : BUSINESS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col" onClick={redirectSalesBusinessProfi}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={hotelIcon} alt="icon" width="30" className='dashboard-icon'></img>

                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden" style={{ whiteSpace: "nowrap" }} >SALES : BUSINESS-PROFI</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {/* SALES : BUSINESS - MRA */}
                <div className="col" onClick={redirectSalesBusinessMra}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={businessIcon} alt="icon" width="30" className='dashboard-icon'></img>
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden" >MARKET RESEARCH ASSOCIATE</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SALES : BROADBAND card */}
                <div className="col" onClick={redirectSalesBroadband}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={businessIcon} alt="icon" width="30" className='dashboard-icon'></img>
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden">SALES : BROADBAND</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* INSTALLATION Card */}
                <div className="col" onClick={redirectInstallation}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={installIcon} alt="icon" width="30" className='dashboard-icon'></img>

                                {/* <i className="fa-solid fa-percent p-2 m-3"></i> */}
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden">INSTALLATION</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* FAULT REPAIR Card */}
                <div className="col" onClick={redirectfaultRepair}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={faultRepairIcon} alt="icon" width="30" className='dashboard-icon'></img>

                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden">FAULT REPAIR</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* SEARCH CUSTOMER SR Card */}
                <div className="col" onClick={redirectCustomerSR}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={searchI} alt="icon" width="30" className='dashboard-icon'></img>
                                {/* <i className="fa-solid fa-percent p-2 m-3"></i> */}
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden" style={{ whiteSpace: "nowrap" }}>SEARCH CUSTOMER SR</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* CUSTOMER INFRA Card */}
                <div className="col" onClick={redirectCustomerInfra}>
                    <div className="card mb-2 mt-2 ">
                        <div className="m-1" style={{ display: "inline-flex" }}>
                            <div className="card-icon">
                                <img src={infraIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                {/* <i className="fa-solid fa-percent p-2 m-3"></i> */}
                            </div>
                            <div className="m-1">
                                <div className="card-body">
                                    <p className="card-text card-title overflow-hidden">CUSTOMER INFRA</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* PROVISIONING APP Card */}
                <div className="col">
                    <a href='https://gponapp.spectra.co:9075' target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: 'black' }}>
                        <div className="card mb-2 mt-2 ">
                            <div className="m-1" style={{ display: "inline-flex" }}>
                                <div className="card-icon">
                                    <img src={provisionIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                    {/* <i className="fa-solid fa-percent p-2 m-3"></i> */}
                                </div>
                                <div className="m-1">
                                    <div className="card-body">
                                        <p className="card-text card-title overflow-hidden">PROVISIONING APP</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>




            </div>
        </div>
    );
};

export default CardList;
